import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const CanonicalLink = () => {
  const location = useLocation();
  const canonicalUrl = `https://www.kmkit.com${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalLink;